var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.stats.stats.length !== 0
    ? _c(
        "b-card",
        { staticClass: "stats-block", attrs: { title: _vm.stats.title } },
        [
          _c(
            "b-list-group",
            [
              _vm._l(_vm.stats.stats, function(stat) {
                return _c("stat-row-display", {
                  key: stat.idStage,
                  attrs: { stat: stat }
                })
              }),
              _vm._v(" "),
              _c("stats-order-summary-row", {
                attrs: { stats: _vm.stats.stats }
              })
            ],
            2
          )
        ],
        1
      )
    : _c("div", [_vm._v("\n    За выбранный период заказов не найдено\n")])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4130244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4130244","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatsOrderBlock.vue
// module id = null
// module chunks = 